import React, {useState} from "react";
import {Video,} from "lucide-react";
import { SiYoutube } from 'react-icons/si';

const LinkAccountModal = ({
                              linkedAccounts,
                              setShowLinkAccountModal,
                              handleTikTokSignIn,
                              handleGoogleSignIn, platforms }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const platformsToLink = platforms.filter(platform => !linkedAccounts[platform]);
    const handleLinkAccount = async (platform) => {
        setShowLinkAccountModal(false)
        setIsLoading(true);
        setError('');
        try {
            if (platform === 'YouTube Shorts') return handleGoogleSignIn();
            return handleTikTokSignIn();
        } catch (error) {
            setError(`Failed to link ${platform} account. Please try again.`);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Link Your Account</h3>
                <p className="mb-4 text-sm text-gray-500">
                    To publish to {platformsToLink.join(' and ')}, you need to link your account{platformsToLink.length > 1 ? 's' : ''} first.
                </p>
                <p className="mb-4 text-sm text-indigo-600 font-medium">
                    Don't worry! Your progress will be saved as a draft while you link your account.
                </p>
                {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
                <div className="space-y-4 mb-6">
                    {platformsToLink.map(platform => (
                        <button
                            key={platform}
                            onClick={() => handleLinkAccount(platform)}
                            disabled={isLoading}
                            className="w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {platform === 'YouTube Shorts' ? (
                                <SiYoutube className="w-5 h-5 mr-2" />
                            ) : (
                                <Video className="w-5 h-5 mr-2" />
                            )}
                            {isLoading ? 'Linking...' : `Link ${platform}`}
                        </button>
                    ))}
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={() => {
                            setShowLinkAccountModal(false);
                            setIsLoading(false);
                            // if (seriesData.platforms.every(platform => linkedAccounts[platform])) {
                            //     handlePublish();
                            // }
                        }}
                        className="flex items-center px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>    );
};

export default LinkAccountModal;
